import {AfterViewChecked, ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation} from '@angular/core';
import {PrismService} from '../../services/prism.service'; // *** WARNING *** NEVER SORT THESE IMPORTS ANYWHERE ELSE ***

import 'prismjs/plugins/toolbar/prism-toolbar'; // *** WARNING *** NEVER SORT THESE IMPORTS ANYWHERE ELSE ***
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'; // *** WARNING *** NEVER SORT THESE IMPORTS ANYWHERE ELSE ***
import 'prismjs/plugins/line-numbers/prism-line-numbers'; // *** WARNING *** NEVER SORT THESE IMPORTS ANYWHERE ELSE ***
import 'prismjs/plugins/previewers/prism-previewers'; // *** WARNING *** NEVER SORT THESE IMPORTS ANYWHERE ELSE ***

@Component({
  selector: 'cc-code-highlighter',
  template: '',
  styleUrls: [
    './code-highlighter.component.less',
    './code-highlighter.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CodeHighlighterComponent implements AfterViewChecked {
  constructor(private readonly elementRef: ElementRef, private readonly prismService: PrismService) {
  }

  ngAfterViewChecked() {
    this.prismService.highlightAllUnder(this.elementRef.nativeElement);
  }
}
